import { render, staticRenderFns } from "./editRule.vue?vue&type=template&id=d2e8480c&"
import script from "./editRule.vue?vue&type=script&lang=js&"
export * from "./editRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports